import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ExtendTheSxProp from './ExtendTheSxProp';
import ClientProvider from './client';
export default createDemo(import.meta.url, ExtendTheSxProp, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/experimental-api/configure-the-sx-prop/demos/extend-the-sx-prop/ExtendTheSxProp.tsx",
    "fileName": "ExtendTheSxProp.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { Box, handleBreakpoints } from '@mui/system';\nimport { createTheme, ThemeProvider } from '@mui/material/styles';\n\nconst customTheme = createTheme({\n  unstable_sxConfig: {\n    size: {\n      style: (props) => {\n        const { size, theme } = props;\n\n        const styleFromPropValue = (propValueFinal: number) => {\n          const value = theme.spacing(propValueFinal);\n\n          return {\n            width: value,\n            height: value,\n          };\n        };\n\n        // Adding support for the breakpoints syntax\n        return handleBreakpoints(props, size, styleFromPropValue);\n      },\n    },\n  },\n});\n\nexport default function ExtendTheSxProp() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={customTheme}>\n      <Box sx={{ size: 10, border: 1 }} />\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 32,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { Box, handleBreakpoints } from '@mui/system';\nimport { createTheme, ThemeProvider } from '@mui/material/styles';\n\nconst customTheme = createTheme({\n  unstable_sxConfig: {\n    size: {\n      style: (props) => {\n        const { size, theme } = props;\n\n        const styleFromPropValue = (propValueFinal: number) => {\n          const value = theme.spacing(propValueFinal);\n\n          return {\n            width: value,\n            height: value,\n          };\n        };\n\n        // Adding support for the breakpoints syntax\n        return handleBreakpoints(props, size, styleFromPropValue);\n      },\n    },\n  },\n});\n\nexport default function ExtendTheSxProp() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <ThemeProvider theme={customTheme}>\n      <Box sx={{ size: 10, border: 1 }} />\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "customTheme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "size"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "10"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "border"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 32,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "@mui/system",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
